import styled from 'styled-components';
import { media } from 'theme';

export const PageContent = styled.div`
  width: 904px;
  padding: 23px 35px;
  background: white;
  margin: 0 auto;
  border-radius: 4px;

  ${media.largeAndDown`
    width: 100%;
    padding: 23px 25px;
  `}
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  margin-top: 15px;
  text-align: left;
`;

export const Text = styled.div`
  * {
    margin-bottom: 25px;
  }

  h2 {
    font-size: 18px;
    color: ${props => props.theme.colors.neutral7};
    margin-bottom: 15px;
    margin-top: 5px;

    ${media.smallAndUp`
      font-size: 24px;
    `}
  }

  h3 {
    margin-bottom: 15px;
  }

  img {
    max-width: 100%;
    width: 100%;
    margin: 0;

    ${media.ie`
      flex: none;
    `}
  }

  ul > li {
    list-style-type: circle;
    margin-bottom: 0;
  }

  ol > li {
    list-style-type: decimal;
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 0;
  }

  li {
    margin-left: 30px;
    padding-bottom: 3px;
  }

  a:link {
    color: ${props => props.theme.colors.seedlyBlue};
  }

  a:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;
